import { t } from "@/i18n-js/instance";
import { TrendDelta } from "@/react/components/Analytics/components/TrendDelta";
import { Typography } from "@/react/components/shared/uikit/Typography";

interface MembersDataItem {
  active_members?: number;
  Date: string;
  new_members?: number;
  total_members?: number;
}

interface MembersTooltipProps {
  data: MembersDataItem;
  headerLabel?: string;
  rootLocale: string;
  trendDeltaPercentage?: number;
}

export const MembersTooltip = ({
  data,
  rootLocale,
  headerLabel,
  trendDeltaPercentage,
}: MembersTooltipProps) => {
  const value =
    data.total_members || data.new_members || data.active_members || 0;

  return (
    <div className="bg-primary w-max rounded-lg p-4 shadow-md">
      {headerLabel && (
        <div className="mb-2">
          <Typography.LabelSm weight="semibold">
            {headerLabel}
          </Typography.LabelSm>
        </div>
      )}
      <div className="flex items-center justify-between gap-4">
        <Typography.LabelSm weight="semibold">
          {t([rootLocale, "members"])}:
        </Typography.LabelSm>
        <div className="flex items-center gap-2">
          <Typography.LabelSm weight="semibold">
            {value.toLocaleString()}
          </Typography.LabelSm>
          {typeof trendDeltaPercentage === "number" ? (
            <TrendDelta
              deltaPercentage={trendDeltaPercentage}
              withBackground={false}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
